module.exports = require('lodash').isUndefined